import { render, staticRenderFns } from "./Administradores.vue?vue&type=template&id=a0714d08&scoped=true&"
import script from "./Administradores.vue?vue&type=script&lang=js&"
export * from "./Administradores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0714d08",
  null
  
)

export default component.exports